// extracted by mini-css-extract-plugin
export default {"wrapper":"SportList_wrapper__DGjuu","emptyMessage":"SportList_emptyMessage__RGxZf"};